module.exports = __webpack_public_path__ + "assets/181451339ef98dee81ad202f12aa62d6.png";